import request from '../../untils/request';

// 线下电费充值
export function OfflineCharge(data) {
  return request({
    url: '/lesseeAccount/offlineCharge',
    method: 'post',
    data: data,
  });
}
// 商户信息查询
export function selectListLessee(data) {
  return request({
    url: '/lessee/selectList',
    method: 'get',
    params: data,
  });
}
// 查询某个商户
export function selectOneByLesseeId(data) {
  return request({
    url: '/lessee/selectOneByLesseeId',
    method: 'get',
    params: data,
  });
}

// 售电订单打印数据
export function getPrintData(data) {
  return request({
    url: '/payOrder/getPrintData',
    method: 'get',
    params: { orderNo: data },
  });
}
